import { transition, verticalFadeIn } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { BlogCardStyles } from '@stories/Components/Cards/BlogCard/BlogCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const MotionWrapper = styled(m.div).attrs((props) => ({
    initial: 'hidden',
    animate: props['data-in-view'] ? 'visible' : 'hidden',
    transition: {
        staggerChildren: 0.1,
    },
})) `
  display: contents;
`;
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    display: flex;
    flex-direction: column;
  }
`;
const TopSection = styled(m.div).attrs(() => ({
    variants: {
        visible: {
            transition: {
                staggerChildren: 0.1,
            },
        },
    },
})) `
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: ${fluid(20, 59)};
`;
const Title = styled(m.h3).attrs(() => ({ variants: verticalFadeIn(15) })) `
  margin: 0;
  margin-bottom: 12px;
  font-size: 32px;
  line-height: 32px;
  text-align: center;
  ${fonts.poppins.extraBold};

  color: ${brand.primary.black};
  [data-variant='charcoal'] & {
    color: ${brand.primary.white};
  }
`;
const Intro = styled(m.p).attrs(() => ({ variants: verticalFadeIn(15) })) `
  margin: 0;
  font-size: ${fluid(14, 16)};
  line-height: 26px;
  text-align: center;
  ${fonts.poppins.regular};

  color: ${brand.primary.black};
  [data-variant='charcoal'] & {
    color: ${brand.primary.white};
  }

  max-width: 757px;
`;
const BigBlogCard = styled(m.a).attrs(() => ({
    variants: verticalFadeIn(25),
    transition: {
        delay: 0.35,
        staggerChildren: 0.1,
        delayChildren: 0.5,
    },
})) `
  display: block;
  text-decoration: none;
  width: 100%;
  border-radius: ${fluid(16, 24)};
  overflow: hidden;
  padding: 40px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  ${BlogCardStyles.Title} {
    ${transition('text-decoration-color', 0.2)};

    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 4px;
    text-decoration-color: transparent;
  }

  &:hover,
  &:focus-visible {
    ${BlogCardStyles.Title} {
      text-decoration-color: currentColor;
    }
  }

  @media ${from(Device.TabletLarge)} {
    padding: 43px;
  }
`;
const CardContent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;

  color: ${brand.primary.white};

  ${BlogCardStyles.TagsWrapper} {
    margin-bottom: ${fluid(20, 24)};
  }

  ${BlogCardStyles.DateEstimatedReadingTime} {
    ${fonts.poppins.bold};
    font-size: ${fluid(13, 18)};
    line-height: ${fluid(14, 16)};
    margin-bottom: ${fluid(12, 16)};
  }

  ${BlogCardStyles.Title} {
    font-size: ${fluid(20, 32)};
    line-height: ${fluid(26, 42)};
    max-width: 1028px;
    text-align: center;
    margin-bottom: ${fluid(20, 24)};
  }

  ${BlogCardStyles.Intro} {
    font-size: ${fluid(14, 20)};
    line-height: ${fluid(22, 26)};
    max-width: 766px;
    text-align: center;
    margin-bottom: ${fluid(20, 24)};

    @media ${until(Device.TabletLarge)} {
      -webkit-line-clamp: unset;
    }

    @media ${from(Device.TabletLarge)} {
      -webkit-line-clamp: 3;
    }
  }
`;
const CardImage = styled.div `
  position: absolute;
  z-index: 0;
  inset: 0;
  width: 100%;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.48);
    @media ${from(Device.TabletLarge)} {
      background: rgba(0, 0, 0, 0.4);
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;
export const FeaturedBannerStyles = {
    Container,
    TopSection,
    Title,
    Intro,
    BigBlogCard,
    CardImage,
    CardContent,
    MotionWrapper,
};
